<template>
	<div id="app">
		<NavBar />
		<Hero scrollto="#end"/>
		<div class="capabilities">
			Our mission is to serve our clients with creativity, integrity and excellence by delivering solutions that embrace the techniques of today and design the experiences of tomorrow. Since opening our doors in 1980, the JD family has continued to grow and evolve, expanding ​into a diverse array of corporate divisions. At every turn, our goal ​is the same — deliver success and serve our clients with creativity, integrity and excellence.  Our extensive in-house capabilities reflect over 35 years of experience in creating turnkey solutions for our clients. Jackson Dawson has become a leader and pioneer in the fields of marketing, worldwide product and culture training, design and fabrication, luxury hospitality, large corporate workshops and consumer experiences — with footprints of more than one million square feet.</div>
		<div class="tabsContainer">
			<div class="tabs">
				<!--<a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Events are What We Do</a>-->
				<a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]" class="verticalAlign"><p>Pre-Event Engagement</p></a>
				<a v-on:click="activetab=2" v-bind:class="[ activetab === 2 ? 'active' : '' ]" class="verticalAlign"><p>On-Site</p></a>
				<a v-on:click="activetab=3" v-bind:class="[ activetab === 3 ? 'active' : '' ]" class="verticalAlign"><p>Post-Event Summary</p></a>
			</div>

			<div class="content">
				<!--
				<div v-if="activetab === 1" class="tabcontent">
					<eventWhatWeDo :list="featureList"></eventWhatWeDo>
				</div>
				-->
				<div v-if="activetab === 1" class="tabcontent">
					<eventPreEngagement></eventPreEngagement>
				</div>
				<div v-if="activetab === 2" class="tabcontent">
				<eventOnSite></eventOnSite>
				</div>
				<div v-if="activetab === 3" class="tabcontent">
					<eventPostSummary></eventPostSummary>
				</div>
			</div>
		</div>

		<div class="footer">
			<div>CONTACT US</div>
			<div>(313)-593-0690</div>
			<a class="footerText" href = "mailto:info@jdeventsolutions.com">
				info@jdeventsolutions.com
			</a>
		</div>
	</div>
</template>

<script>
//import eventWhatWeDo from './components/eventWhatWeDo.vue';
import NavBar from './components/NavBar.vue';
import Hero from './components/Hero.vue';
import eventPreEngagement from './components/eventPreEngagement.vue';
import eventOnSite from './components/eventOnSite.vue';
import eventPostSummary from './components/eventPostSummary.vue';
import './scss/global.scss';

export default {
  name: 'app',
  components: {
	//eventWhatWeDo,
	NavBar,
	Hero,
	eventPreEngagement,
	eventOnSite,
	eventPostSummary

  },
  data() {
	  return {
		  activetab: 1
		  /*,
		  featureList: [
			  {
				  'title' : 'analytics',
				  'blurb' : 'We do the best analytics',
				  'usecases' : [
					  {
						  'title': 'RSG'
					  },
				  ],
				  'caseImg': 'https://cdn.pixabay.com/photo/2018/05/07/10/48/husky-3380548__340.jpg'
			  },
			  {
				  'title' : 'stuff',
				  'blurb' : 'We do the best stuff',
				  'usecases' : [
					  {
						  'title': 'VSR'
					  },
					  {
						  'title': 'LEC'
					  }
				  ],
				  'caseImg': 'https://cdn.pixabay.com/photo/2018/05/07/10/48/husky-3380548__340.jpg'
			  }
		  ]
		  */
	  }
  },
}
</script>

<style lang="scss">


body {
	margin: 0;
}

.verticalAlign {
	display: flex;
	flex-direction: column;
	justify-content: center;
}
#app {
  font-family: 'OpenSans', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: $navHeight;
}

.capabilities {
	padding: 2rem;
}

.tabsContainer {
	max-width: 1200px;
	margin: 0 auto;
}
.tabs {
    display: flex;
	flex-direction: row;
	// flex-wrap: wrap;
	justify-content: space-between;

}

.tabs ul {
    list-style-type: none;
    margin-left: 20px;
}

.tabs a {
	&:nth-child(2) {
		border-right: none;
		border-left: none;
	}
    // float: left;
	cursor: pointer;
	width: 100%;
	// width: 33%;

    transition: background-color 0.2s;
	border: 1px solid $blue;
	border-bottom: none;
    background-color: $lightgrey;
	font-weight: bold;
	
	p {
		pointer-events: none;
	}
}
.tabs a:last-child { 
    border-right: 1px solid $blue;
}

.tabs a:hover {
    background-color: $blue;
    color: #fff;
}

.tabs a.active {
    background-color: $blue;
    color: white;
    cursor: default;
}
.tabcontent {
    padding: 30px;
    border: 1px solid $blue;
    box-shadow: 3px 3px 6px #e1e1e1;
	height: 100%;
}
.footer {
	background-color: $darkblue;
	color: white;
	height: 10%;
	padding: 1%;
}
.footerText {
	color: white;
}
</style>
